import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home.vue";
import result from "../views/result.vue";
import layout from "../views/layout";
import vote from "../views/vote/index";
import publicity from "../views/publicity/index";
import usercenter from "../views/usercenter/index";

Vue.use(VueRouter);

const routes = [

  // 完善信息
  {
    path: "/register",
    component: () => import('../views/components/user.vue'),
    meta: {
      title: "我的信息",
    },
  },

  //首页
  {
    path: "/",
    name: "Home",
    component: layout,
    children: [
      {
        path: "/",
        component: Home,
        meta: {
          title: "维修资金公共服务平台",
        },
      },

    ],
  },
  // 资金查询
  {
    path: "/search",
    component: () => import('../views/components/fundQuery.vue'),
    meta: {
      title: "维修资金公共服务平台",
    },
  },
  // 资金详情
  {
    path: "/fundDetail",
    component: () => import('../views/components/fundDetail.vue'),
    meta: {
      title: "维修资金公共服务平台",
    },
  },
  //资金交存
  {
    path: "/fundSave",
    component: () => import('../views/components/fundSave.vue'),
    meta: {
      title: "维修资金公共服务平台",
    },
  },
  // 交存详情
  {
    path: "/saveDetail",
    component: () => import('../views/components/saveDetail.vue'),
    meta: {
      title: "维修资金公共服务平台",
    },
  },
  // 付款码页面
  {
    path: "/pay",
    component: () => import('../views/components/qrcode.vue'),
    meta: {
      title: "维修资金公共服务平台",
    },
  },
  // 资金开票
  {
    path: "/checkout",
    component: () => import('../views/components/checkOut.vue'),
    meta: {
      title: "维修资金公共服务平台",
    },
  },
  // 投票
  {
    path: "/vote",
    name: "vote",
    component: layout,
    children: [
      {
        path: "/",
        component: vote,
        meta: {
          title: "维修资金公共服务平台",
        },
      },

    ],
  },
  {
    path: "/detail",
    component: () => import('../views/components/voteDetail.vue'),
    meta: {
      title: "维修资金公共服务平台",
    },
  },

  // 公示
  {
    path: "/publicity",
    name: "publicity",
    component: layout,
    children: [
      {
        path: "/",
        component: publicity,
        meta: {
          title: "维修资金公共服务平台",
        },
      },

    ],
  },
  {
    path: "/publicDetail",
    component: () => import('../views/components/publicDetail.vue'),
    meta: {
      title: "维修资金公共服务平台",
    },
  },
  {
    path: "/preview",
    component: () => import('../views/components/pdfNoPage.vue'),
    meta: {
      title: "附件",
    },
  },
  {
    path: "/useDetail",
    component: () => import('../views/components/useDetail.vue'),
    meta: {
      title: "维修资金公共服务平台",
    },
  },
  // 
  {
    path: "/publicVote",
    component: () => import('../views/components/votePublicDetail.vue'),
    meta: {
      title: "维修资金公共服务平台",
    },
  },
  // 我的
  {
    path: "/usercenter",
    name: "usercenter",
    component: layout,
    children: [
      {
        path: "/",
        component: usercenter,
        meta: {
          title: "维修资金公共服务平台",
        },
      },
    ],
  },
  // 修改房屋
  {
    path: "/house",
    component: () => import('../views/components/editHouse.vue'),
    meta: {
      title: "维修资金公共服务平台",
    },
  },
  {
    path: "/repeatOrder",
    name: "repeatOrder",
    component: () => import('../views/components/repeatOrder.vue'),
  },
  // 完善信息
  // {
  //   path: "/user",
  //   component: () => import('../views/components/user.vue'),
  //   meta: {
  //     title: "我的信息",
  //   },
  // },

  // //结果页面
  // {
  //   path: "/result",
  //   name: "result",
  //   component: result,
  // },
];

const router = new VueRouter({
  mode: "history",
  base: 'wxzjgzh',
  routes,
});

export default router;
